module.exports = {
    CONNECT_VERSION_CHECK: '8hEqnttAU4QezPHrtpjc',
    TWITTER_VERSION_CHECK: '',
    TURBO_VERSION_CHECK: '9wfx3UkLAzrQKRuzEsxL'
};


// WEBPACK FOOTER //
// ./app/scripts/constants/_connect.js